<script>
    import Button from "$lib/atoms/Button.svelte";
    import ContainerBgImageHeadlineAndSubtitle from "$lib/components/Container_bg_image_headline_and_subtitle.svelte";
    import ContainerBgImageHeadlineAndSubtitleSuggested from "$lib/components/Container_bg_image_headline_and_subtitle_suggested.svelte";
    import "../../../../../app.css";
    import { ArrowRight } from "lucide-svelte";
    import { t } from "$lib/i18n.js";
</script>

<section>
        <div class="row">
            <img src="https://assets.auting.it/images/logo/superowner.svg" alt="SuperOwner Logo"/>
            <h3 class="accent">SuperOwner</h3>
        </div>
        <h2>{$t('routes.owner.super_owner.title')}</h2>
        <p>{$t('routes.owner.super_owner.text')}</p>
        <Button 
        icon={ArrowRight}
        label={$t('routes.owner.super_owner.cta')} backgroundColor={'var(--on-surface)'}
        href='https://scopri.auting.it/superowner/'
        />

</section>

<style>
    section {
        padding-top: 140px;
        padding-bottom: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;
    }

    h2 {
        font-family: var(--font-body);
    }

    .row {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }

    .row img {
        width: 72px;
    }

    .row h3 {
        font-family: var(--font-body);
        font-size: 32px;
        margin: 0;
        padding: 0;
        color: var(--water-green);
        text-align: center;
    }

    h2 {
        text-align: center;
    }

    p {
        text-align: center;
    }
</style>
